import React from "react";
import { useTheme } from "../hooks/useTheme";
import wordmarkOnLight from "../assets/logo-wordmark-on-light.png";
import wordmarkOnDark from "../assets/logo-wordmark-on-dark.png";

// The branded header band on the site-wide Home cards: the wordmark, then the
// card's name. Same light blue as SeasonCountdown.
//
// It carries logo-wordmark-on-light.png, the current mark. The band previously
// used logo-wordmark-transparent.png because that was the only wordmark with
// an alpha channel; the new mark has one too, so the constraint that picked
// the old file no longer applies. The name says which background it is for,
// since its navy ink disappears on a dark band and the on-dark twin exists for
// that case.
function LineupBanner({ title }) {
  const { theme } = useTheme();
  return (
    <div style={{ backgroundColor: "var(--color-band-bg)", borderBottom: "1px solid var(--color-band-border)", padding: "14px 16px", display: "flex", alignItems: "center", justifyContent: "center", gap: 10 }}>
      <img
        src={theme === "dark" ? wordmarkOnDark : wordmarkOnLight}
        alt="Lineup"
        style={{ height: 26, width: "auto", display: "block" }}
      />
      <span style={{ fontSize: 16, fontWeight: 900, color: "var(--color-text-strong)", letterSpacing: "0.02em", textTransform: "uppercase", whiteSpace: "nowrap" }}>
        {title}
      </span>
    </div>
  );
}

export default LineupBanner;
